import { useEffect } from "react";
import { useAdminPageTitle } from "@/contexts/admin-page-title-context";

const UsersPage = () => {
  const { setPageTitle } = useAdminPageTitle();

  useEffect(() => {
    setPageTitle("Users");
  }, [setPageTitle]);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-[#202020]">Users</h1>
    </div>
  );
};

export default UsersPage;